import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3NiwelacjaTerenu from "../../components/offer/3niwelacjaTerenu";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Niwelacja terenu pod założenie ogrodu i trawnika | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Niwelacja terenu pod założenie ogrodu i trawnika | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Profesjonalne kształtowanie, skarpowanie i niwelacja terenu przed założeniem wymarzonego ogrodu lub trawnika w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Niwelacja terenu pod założenie ogrodu i trawnika | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Profesjonalne kształtowanie, skarpowanie i niwelacja terenu przed założeniem wymarzonego ogrodu lub trawnika w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3NiwelacjaTerenu />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
